import React, { useMemo } from 'react';
import { Field, FieldTypes } from '@common-fe/common-fe';

import { CloseAccountCheckbox } from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxForm/components';

const useLockboxOutboundTOACloseAccountFields = () => {
  const lockboxOutboundTOACloseAccountFields = useMemo(() => [
    {
      type: FieldTypes.Node,
      name: 'Close account',
      label: 'Close account',
      value: <CloseAccountCheckbox />,
      node: <CloseAccountCheckbox />,
      fieldWrapperStyles: { alignSelf: 'flex-start' },
    }
  ], []);

  return {
    lockboxOutboundTOACloseAccountFields: lockboxOutboundTOACloseAccountFields as Field[],
  };
};

export default useLockboxOutboundTOACloseAccountFields;
